import {
    GET_PO_DETAILS, GET_PO_SEARCH,
    POST_PO_LINEITEMS, INSPECTION_DASHBOARD,
    GET_STAGES_BY_POLINEITEMID, GET_SUPPLIER_POS, POST_CLAIM_PO,
    POST_SAVE_LINE_ITEM_PO,
    POST_UNCLAIM_PO,
    POST_PO_SEARCH,
    POST_SEND_COMMENT,
    POST_EDIT_STAGE,
    PO_ACCEPTANCE_TO_PO,
    GET_DOCUMENT_FOR_ADVANCE,
    POST_POACCEPTANCE_DOCUMENT_APPROVAL,
    POST_UPDATE_DOCUMENTID_FOR_ADAVANCE,
    POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS,
    POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT,
    GET_PAYMENT_TERM_DETAILS,
    GET_PAYMENT_TERM_DOCUMENTS,
    GET_ALL_PO_LIST_BY_USERID,
    GET_POLINEITEM_BY_POID,
    POST_CLAIM_PO_FOR_EXPEDITOR,
    POST_UNCLAIM_PO_FOR_EXPEDITOR,
    GET_PO_AND_POLINEITEMS_SEARCH,
    GET_PAYMENT_TERM_DETAILS_BY_PO_ID,
    GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS,
    GET_PAYMENT_TERM_SEARCH,
    GET_PROJECT_ALLOCATION_DETAILS,
    POST_ADDITIONAL_EMAILID,
    GET_EXCEL_EXPORT_DATA,
    GET_DRAFT_DOCUMENTS,
    GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS,
    GET_ALL_GRNS,
    GET_ALL_GRN_EXPORT,
    GET_POLINEITEMS_FOR_SAMETEMPLATE,
    GET_SAME_STAGES_BYLINEITEMID,
    UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT,
    GET_PROJECT_ALLOCATION_BY_USERID,
    GET_DOCUMENT_FOR_QA,
    GET_DOCUMENT_FOR_QA_ERROR,
    GET_QADOCUMENT_BY_POLINEITEMID,
    GET_QADOCUMENT_BY_POLINEITEMID_ERROR,
    GET_QA_ACTIVITY,
    GET_QA_ACTIVITY_ERROR,
    POST_NON_PO,
    POST_NON_PO_ERROR,
    GET_PO_LINEITEM_DETAILS,
    GET_PO_LINEITEM_DETAILS_ERROR,
} from '../type'

const initialState = {
    poDetails: [],
    poSearch: [],
    loading: true,
    inspectionDashboard: [1, 2, 3],
    pos: [],
    stagesByPOLineItemId: [],
    postClaimStatus: '',
    saveLineItemStatus: '',
    postUnClaimStatus: '',
    searchResults: [],
    comment: [],
    templateEdited: "",
    poDetailsForAdvance: [],
    approvalStatus: [],
    upDateStatus: '',
    AdvanceDocumentStatusUpdate: [],
    poDetailsDocument: [],
    paymentTermData: [],
    polist: [],
    poitemlist: [],
    paymentTermDocuments: [],
    postClaimStatusByExpeditor: [],
    postUnClaimStatusByExpeditor: [],
    poAndPoLineItemSearch: [],
    paymentTermDetailsByPoId: [],
    paymentTermApprovalByCPMandTPM: [],
    paymentTermDocumentsMultiplePos: [],
    ProjectAllocationsDetails: [],
    additionalEmailId: [],
    excelData: [],
    DraftDocuments: [],
    LogisticsData: [],
    getGRNDetails: [],
    getGRNDetailsExport: [],
    getPOLineItemsForSameTemplate: [],
    getSameTemplate: [],
    updatedocumentid: [],
    getProjectAllocationByUserId: [],
    qaDocuments: [],
    qaDocumentsError: [],
    qaDocumentsByPOLineItemId: [],
    qaDocumentsByPOLineItemIdError: [],
    qaActivity: [],
    qaActivityError: [],
    nonPODetails: [],
    nonPODetailsError: [],
    poLineItemDetails: [],
    poLineItemDetailsError: [],
}

export default function poDetailsReducer(state = initialState, action) {
    switch (action.type) {

        case GET_PO_DETAILS:
            return {
                ...state,
                poDetails: action.payload,
                loading: false

            }
        case GET_PO_SEARCH:
            return {
                ...state,
                poSearch: action.payload,
                loading: false

            }
        case POST_PO_LINEITEMS:
            return {
                ...state,
            }
        case INSPECTION_DASHBOARD:
            return {
                ...state,
            }
        case GET_STAGES_BY_POLINEITEMID:
            return {
                ...state,
                stagesByPOLineitemID: action.payload,
                loading: false

            }
        case GET_SUPPLIER_POS:
            return {
                ...state,
                pos: action.payload,
                loading: false

            }
        case POST_CLAIM_PO:
            return {
                ...state,
                postClaimStatus: action.payload
            }
        case POST_UNCLAIM_PO:
            return {
                ...state,
                postUnClaimStatus: action.payload
            }
        case POST_SAVE_LINE_ITEM_PO:
            return {
                ...state,
                saveLineItemStatus: action.payload

            }
        case POST_PO_SEARCH:
            return {
                ...state,
                searchResults: action.payload

            }
        case POST_SEND_COMMENT:
            return {
                ...state,
                comment: action.payload

            }
        case POST_EDIT_STAGE:
            return {
                ...state,
                templateEdited: action.payload

            }
        case PO_ACCEPTANCE_TO_PO:
            return {
                ...state,
                loading: false

            }
        case GET_DOCUMENT_FOR_ADVANCE:
            return {
                ...state,
                poDetailsForAdvance: action.payload

            }
        case POST_POACCEPTANCE_DOCUMENT_APPROVAL:
            return {
                ...state,
                approvalStatus: action.payload

            }
        case POST_UPDATE_DOCUMENTID_FOR_ADAVANCE:
            return {
                ...state,
                upDateStatus: action.payload

            }
        case POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS:
            return {
                ...state,
                AdvanceDocumentStatusUpdate: action.payload

            }
        case POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT:
            return {
                ...state,
                poDetailsDocument: action.payload,
                loading: false
            }
        case GET_PAYMENT_TERM_DETAILS:
            return {
                ...state,
                paymentTermData: action.payload,
                loading: false
            }
        case GET_PAYMENT_TERM_DOCUMENTS:
            return {
                ...state,
                paymentTermDocuments: action.payload,
                loading: false
            }
        case GET_ALL_PO_LIST_BY_USERID:
            return {
                ...state,
                polist: action.payload,
                loading: false
            }
        case GET_POLINEITEM_BY_POID:
            return {
                ...state,
                poitemlist: action.payload,
                loading: false
            }
        case POST_CLAIM_PO_FOR_EXPEDITOR:
            return {
                ...state,
                postClaimStatusByExpeditor: action.payload
            }
        case POST_UNCLAIM_PO_FOR_EXPEDITOR:
            return {
                ...state,
                postUnClaimStatusByExpeditor: action.payload
            }
        case GET_PO_AND_POLINEITEMS_SEARCH:
            return {
                ...state,
                poAndPoLineItemSearch: action.payload,
                loading: false
            }
        case GET_PAYMENT_TERM_DETAILS_BY_PO_ID:
            return {
                ...state,
                paymentTermDetailsByPoId: action.payload,
                loading: false

            }
        case GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS:
            return {
                ...state,
                paymentTermApprovalByCPMandTPM: action.payload,
                loading: false
            }
        case GET_PAYMENT_TERM_SEARCH:
            return {
                ...state,
                paymentTermDocumentsMultiplePos: action.payload,
                loading: false
            }
        case GET_PROJECT_ALLOCATION_DETAILS:
            return {
                ...state,
                ProjectAllocationsDetails: action.payload,
                loading: false
            }
        case POST_ADDITIONAL_EMAILID:
            return {
                ...state,
                additionalEmailId: action.payload,
                loading: false
            }
        case GET_EXCEL_EXPORT_DATA:
            return {
                ...state,
                excelData: action.payload,
                loading: false
            }
        case GET_DRAFT_DOCUMENTS:
            return {
                ...state,
                DraftDocuments: action.payload,
                loading: false
            }
        case GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS:
            return {
                ...state,
                LogisticsData: action.payload,
                loading: false
            }
        case GET_ALL_GRNS:
            return {
                ...state,
                getGRNDetails: action.payload,
                loading: false
            }
        case GET_ALL_GRN_EXPORT:
            return {
                ...state,
                getGRNDetailsExport: action.payload,
                loading: false
            }
        case GET_POLINEITEMS_FOR_SAMETEMPLATE:
            return {
                ...state,
                getPOLineItemsForSameTemplate: action.payload,
                loading: false
            }
        case GET_SAME_STAGES_BYLINEITEMID:
            return {
                ...state,
                getSameTemplate: action.payload,
                loading: false
            }
        case UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT:
            return {
                ...state,
                updatedocumentid: action.payload,
                loading: false
            }
        case GET_PROJECT_ALLOCATION_BY_USERID:
            return {
                ...state,
                getProjectAllocationByUserId: action.payload,
                loading: false
            }
        case GET_DOCUMENT_FOR_QA:
            return {
                ...state,
                qaDocuments: action.payload,
                loading: false
            }
        case GET_DOCUMENT_FOR_QA_ERROR:
            return {
                ...state,
                qaDocumentsError: action.payload,
                loading: false
            }
        case GET_QADOCUMENT_BY_POLINEITEMID:
            return {
                ...state,
                qaDocumentsByPOLineItemId: action.payload,
                loading: false
            }
        case GET_QADOCUMENT_BY_POLINEITEMID_ERROR:
            return {
                ...state,
                qaDocumentsByPOLineItemIdError: action.payload,
                loading: false
            }
        case GET_QA_ACTIVITY:
            return {
                ...state,
                qaActivity: action.payload,
                loading: false
            }
        case GET_QA_ACTIVITY_ERROR:
            return {
                ...state,
                qaActivityError: action.payload,
                loading: false
            }
        case POST_NON_PO:
            return {
                ...state,
                nonPODetails: action.payload,
                loading: false
            }
        case POST_NON_PO_ERROR:
            return {
                ...state,
                nonPODetailsError: action.payload,
                loading: false
            }
        case GET_PO_LINEITEM_DETAILS:
            return {
                ...state,
                poLineItemDetails: action.payload,
                loading: false
            }
        case GET_PO_LINEITEM_DETAILS_ERROR:
            return {
                ...state,
                poLineItemDetailsError: action.payload,
                loading: false
            }
        default: return state
    }

}
